import * as z from "zod";

export const LSVehicleTypesSchema = z.object({
	vehicleTypeKey: z.string(),
	vehicleTypeID: z.string(),

	vehicleTypeName: z.string(),
	vehicleTypeDesc: z.string(),
	vehicleTypeNotes: z.string(),
	maxItem: z.number(),
	maxWidth: z.number(),
	maxHeight: z.number(),
	maxLength: z.number(),
	maxWeight: z.number(),

	vehicleTypeWeight: z.number().nullable(),

	vehicleTypePhoto: z.base64(),
});

export type LSVehicleTypes = z.infer<typeof LSVehicleTypesSchema>;
